module.exports = new __parcel__URL__("illustration.fd46dedc.svg").toString();